export default __webpack_public_path__ + "static/media/tas-pink.94791830.png";